import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TelecomService } from 'src/app/services/telecom/telecom.service';
import { TimeService } from 'src/app/services/time/time.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
  selector: 'app-closures',
  templateUrl: './closures.component.html',
  styleUrls: ['./closures.component.css']
})
export class ClosuresComponent implements OnInit {

  lambdaMessage: string = "";
  lambdaError: boolean = false;

  closureData: Array<any> = [];
  filteredClosures: Array<any> = [];
  inactiveClosureData: Array<any> = [];
  currentClosureData: Array<any> = [];
  upcomingClosureData: Array<any> = [];
  futureClosureData: Array<any> = [];
  historicalClosureData: Array<any> = [];
  
  lobSelected: string = "All LOBs";
  groupSelected: any = "All Groups";
  queueSelected: any = "All Queues";
  closureType = "Upcoming";

  formValid: boolean = false;
  maxDate;
  minDate;
  queueData: Array<any> = [];
  lobs: Array<any> = [];
  groups: Array<any> = [];
  idMap: Map<string, any>;
  value = false;
  selectedClosures : Array<any> = [];
  filteredGroups: any[];
  filteredQueues: any[];
  showAll: boolean = true;
  searchString: string;

  currentUser:string = '';
  isTelecom:boolean;
  shutdownUrl:string = '/emergencyShutdown';


  constructor(private telecomService: TelecomService, private config:ConfigService, private timeService:TimeService, private auth:AuthService) { }

  ngOnInit(): void {
    this.getClosures();
    this.getQueues();
    this.getGroups();
    this.getLOBs();
    let user = this.auth.userPool.getCurrentUser().username;
    this.currentUser = user.split('_')[1].split('@')[0];
    this.isTelecom = this.auth.memberOf.includes(environment.roles.telecom);
    if(!this.isTelecom && this.config.activeConfig!=null){
      this.lobSelected = this.config.activeLOB;
    }
    if(this.config.activeLOB){
      this.shutdownUrl = '/' + this.config.activeLOB + this.shutdownUrl;
    }
    console.log(this.shutdownUrl);
    this.buildIdMap();
    this.filterQueues();
  }

  filterQueues(){
    this.filteredGroups = this.groups.filter(group => {
      if(this.lobSelected == "All LOBs" || group.LOB == this.lobSelected){
        return true;
      }
      return false;
    });
     this.filteredQueues = this.queueData.filter(queue => {
       if(this.lobSelected == "All LOBs" || queue.LOB == this.lobSelected){
        if(this.groupSelected == "All Groups" || queue.groupId == this.groupSelected){
            return true;
        } 
       }
       return false;
     });
      this.filterClosures();
      this.sortClosures();
  }

  filterClosures(){
    this.filteredClosures = this.closureData.filter(message =>{
      if(this.lobSelected == "All LOBs" || message.message.LOB == this.lobSelected){
        if(this.groupSelected== "All Groups" || message.groupId == this.groupSelected.groupId){
          if(this.queueSelected == "All Queues" || message.queueId == this.queueSelected.queueId){
            return true;
          }
        }
      }
      return false;
    });
  }

  selectClosure(closureId){
    let closureIndex = this.selectedClosures.findIndex(index => closureId == index);

    if(closureIndex == -1){
      this.selectedClosures.push(closureId);
    }
    else{
      this.selectedClosures.splice(closureIndex,1);
    }
  }
  endSelectedClosures(){
    for(let i=0;i<this.selectedClosures.length;i++){
      //disable these queues
      let closureIndex = this.closureData.findIndex(
        closure => (this.selectedClosures[i].messageId == closure.messageId 
        && this.selectedClosures[i].queueId == closure.queueId ));
      if(closureIndex != -1){
        let now = new Date();
        this.closureData[closureIndex].message.status = "Disabled";
        this.closureData[closureIndex].messageDuration.messageEndDate = this.timeService.wireFormatDate(now, 0);
        this.closureData[closureIndex].messageDuration.messageEndTime = this.timeService.formatTime(now);
        this.closureData[closureIndex].closureStatus = "Historical";
        this.closureData[closureIndex].lastUpdated = this.timeService.getDateTimeString(now);
        this.closureData[closureIndex].updatedBy = this.currentUser;
        console.log("Disabled: ",this.closureData[closureIndex]);
      }
    }
    this.sortClosures();
    this.updateClosures();
    this.selectedClosures = [];
  }

  updateClosures(){
    let row = {action:"put", item: this.closureData};
    this.telecomService.saveRow(row, environment.ClosureMessagesLambdaName).then((data: any) => {
      if(data.statusCode == 200){
        this.lambdaError = false;
        this.lambdaMessage = "Closure(s) ended successfully.";
        }
        else{
          this.lambdaError = true;
          this.lambdaMessage = "Unable to save changes.";
          console.error(data.Error);
        }
    });
  }

  updateItem(closure:any){
    let items = [];
    items.push(closure.item);
    let row = {action:"put", item: items};
    this.lambdaError = false;
    this.lambdaMessage = 'Saving Changes...'
    this.telecomService.saveRow(row, environment.ClosureMessagesLambdaName).then((data: any) => {
      if(data.statusCode == 200){
        this.lambdaError = false;
        this.lambdaMessage = "Closure updated successfully.";
        }
        else{
          this.lambdaError = true;
          this.lambdaMessage = "Unable to save changes.";
          console.error(data.Error);
        }
    });
  }

  validate(item){
    this.lambdaMessage = '';
    this.lambdaError = false;

    if(!item.messageDuration.messageEndDate){
      this.lambdaMessage = "End date is required."
      this.lambdaError = true;
      return false;
    }   
    if(!item.messageDuration.messageEndTime){
      this.lambdaMessage = "End time is required."
      this.lambdaError = true;
      return false;
    }
    return true;
  }

  buildIdMap(){
    this.idMap = new Map<string, any>();

    //if there is no group set
    this.idMap.set(undefined, {groupName:""});
    this.idMap.set(null, {groupName:""});
    this.idMap.set("", {groupName:""});
    //
    for(let i=0;i<this.queueData.length;i++){
      this.idMap.set(this.queueData[i].queueId, this.queueData[i]);
    }
    //
    for(let i=0;i<this.closureData.length;i++){
      
      console.log(this.closureData[i].closureId);
      this.idMap.set(this.closureData[i].closureId, this.closureData[i]);
    }
    //
    for(let i=0;i<this.groups.length;i++){
      this.idMap.set(this.groups[i].groupId, this.groups[i])
    }
    console.log(this.idMap);
  }

  getClosures(){
    this.telecomService.getRows(environment.ClosureMessagesLambdaName).then((data: any) => {
      if(data.statusCode == 200){
        console.log(data);
        this.closureData = data.body.closureMessages;
        // console.log("Closure Data: ", this.closureData)
      }
      else{
        console.error(data.Error)
      }
      this.filterQueues();
      this.buildIdMap();
    });
  }

      //method to sort closures into historical, current, upcoming and future
  sortClosures(){
    console.log("filtered Closures: ",this.filteredClosures)
    this.currentClosureData = [];
    this.upcomingClosureData = [];
    this.futureClosureData = [];
    this.historicalClosureData = [];
     for(let i=0;i<this.filteredClosures.length;i++){
       if(this.filteredClosures[i].closureStatus == "Current"){
         //console.log("Current: ", this.closureData[i])
         this.currentClosureData.push(this.filteredClosures[i]);
       }
       else if(this.filteredClosures[i].closureStatus == "Upcoming"){
        //console.log("Upcoming: ", this.closureData[i])
        this.upcomingClosureData.push(this.filteredClosures[i]);
      }
      else if(this.filteredClosures[i].closureStatus == "Historical"){
        //console.log("Historical: ",this.closureData[i])
        this.historicalClosureData.push(this.filteredClosures[i]);
      }
      else if(this.filteredClosures[i].closureStatus == "Future"){
        //console.log("Future: ",this.closureData[i])
        this.futureClosureData.push(this.filteredClosures[i]);
      }
     }
     //Actually sort each dataset
     let sortByDate = (a, b) => {
     let aDate = new Date(a.messageDuration.messageStartDate);
     let bDate = new Date(b.messageDuration.messageStartDate);
      if(aDate.getTime() < bDate.getTime()){
        return -1
      }else if (aDate.getTime() > bDate.getTime()){
        return 1
      }
      return 0;
    }
     this.currentClosureData.sort(sortByDate);
     this.upcomingClosureData.sort(sortByDate);
     this.futureClosureData.sort(sortByDate);
     this.historicalClosureData.sort(sortByDate);

     this.inactiveClosureData = this.setInactiveClosures(this.closureType)
  }

  setInactiveClosures(type:string): any[]{
    if(type == "Upcoming"){
       return this.upcomingClosureData;
    }
    else if(type == "Historical"){
      return this.historicalClosureData;
    }
    else if(type == "Future"){
      return this.futureClosureData;
    }
  }

  getQueues(){
    this.telecomService.getRows(environment.QueuesLambdaName).then((data: any) => {
      if(data.statusCode == 200){
        this.queueData = data.body.queueList;
      }
      else{
        console.error(data.Error)
      }
      this.filterQueues();
      this.buildIdMap();
    });
  }

  getLOBs(){
    this.telecomService.getLOBs().then((resultData:any)=>{
      console.log("get lob result: ", resultData);
      this.lobs = resultData.lobList;
      this.filterQueues();
    });
  }

  getGroups(){
    this.telecomService.getRows(environment.GroupsLambdaName).then((data: any) => {
      if(data.statusCode == 200){
        this.groups = data.body.Group.Item.data;
      }
      else{
        console.error(data.Error)
      }
      this.filterQueues();
      this.buildIdMap();
    });
  }

  applyFilter(){
    let temp = []
    console.log(this.searchString);
    let search = this.searchString.toLowerCase();
    this.setInactiveClosures(this.closureType).map(x => {
      console.log(x);
      for (var key in x.message.msgText){
        let searchItem = x.message.msgText[key];
        if(searchItem.toLowerCase().includes(search)){
            temp.push(x);
        }
      }
    });
    console.log(temp);
    temp.sort((a, b) => {
      console.log(`a:${a} b:${b}`);
      let aDate = new Date(a.messageDuration.messageStartDate);
      let bDate = new Date(b.messageDuration.messageStartDate);
       if(aDate.getTime() < bDate.getTime()){
         return -1
       }else if (aDate.getTime() > bDate.getTime()){
         return 1
       }
       return 0;
     })
    this.inactiveClosureData = JSON.parse(JSON.stringify(temp));
  }

}
